const teamMembers = [
  {
    name: "Dr. Sarah Mensah",
    role: "Chief Medical Officer",
    image: "",
  },
  {
    name: "John Doe",
    role: "Lab Technician",
    image: "",
  },
  {
    name: "Angela Smith",
    role: "Diagnostics Specialist",
    image: "",
  },
];

const getInitial = (fullName) => {
  if (!fullName) return "?";
  return fullName.charAt(0).toUpperCase();
};

const OurTeam = () => {
  return (
    <section className="py-5 bg-light" id="our-team">
      <div className="container">
        <h2 className="text-center text-primary-emphasis mb-4 ">
          Meet Our Team
        </h2>
        <p className="text-center mb-5 text-muted">
          Our highly skilled and compassionate team works tirelessly to deliver
          accurate, timely, and reliable diagnostic services to safeguard your
          health.
        </p>

        <div className=" row g-4">
          {teamMembers.map((member, index) => (
            <div className="col-md-4" key={index}>
              <div className="testimonial-card card bg-warning-subtle border-0 shadow-sm text-center p-4 h-100">
                {member.image ? (
                  <img
                    src={member.image}
                    alt={member.name}
                    className="rounded-circle mx-auto"
                    style={{ width: 100, height: 100, objectFit: "cover" }}
                  />
                ) : (
                  <div
                    style={{
                      width: 100,
                      height: 100,
                      borderRadius: "50%",
                      backgroundColor: "#007",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "white",
                      fontSize: "2rem",
                      fontWeight: "bold",
                      margin: "0 auto",
                    }}
                  >
                    {getInitial(member.name)}
                  </div>
                )}
                <div className="card-body">
                  <h5 className="card-title">{member.name}</h5>
                  <p className="text-muted">{member.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurTeam;
